const carousels = document.querySelectorAll('[data-home-carousel]');

carousels.forEach((carousel) => {
  const track = carousel.querySelector('.np-today-grid');
  const slides = [...carousel.querySelectorAll('.np-today-item')];
  const dotsHost = carousel.querySelector('[data-home-carousel-dots]');
  let active = 0;

  if (!track || slides.length < 2 || !dotsHost) return;

  const dots = slides.map((_, index) => {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = `np-home-carousel__dot${index === 0 ? ' is-active' : ''}`;
    dot.setAttribute('aria-label', `${index + 1}`);
    dot.addEventListener('click', () => goTo(index));
    dotsHost.append(dot);
    return dot;
  });

  const update = (index) => {
    active = index;
    dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === active));
  };

  const goTo = (index) => {
    const next = (index + slides.length) % slides.length;
	track.scrollTo({ left: next * track.clientWidth, behavior: 'smooth' });
    update(next);
  };

  carousel.querySelector('[data-home-carousel-prev]')?.addEventListener('click', () => goTo(active - 1));
  carousel.querySelector('[data-home-carousel-next]')?.addEventListener('click', () => goTo(active + 1));
  track.addEventListener('scroll', () => {
    const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    update(Math.min(slides.length - 1, Math.max(0, index)));
  }, { passive: true });

	let timer = window.setInterval(() => goTo(active + 1), 5000);
	const pause = () => window.clearInterval(timer);
	const resume = () => {
		window.clearInterval(timer);
		timer = window.setInterval(() => goTo(active + 1), 5000);
	};
	carousel.addEventListener('pointerenter', pause);
	carousel.addEventListener('pointerleave', resume);
	carousel.addEventListener('focusin', pause);
	carousel.addEventListener('focusout', resume);
});

document.querySelectorAll('.np-home-premieres').forEach((premieres) => {
	const tabs = [...premieres.querySelectorAll('[data-home-premiere-tab]')];
	const panels = [...premieres.querySelectorAll('[data-home-premiere-panel]')];
	let active = 0;

	if (tabs.length < 2) return;

	const show = (index) => {
		active = (index + tabs.length) % tabs.length;
		tabs.forEach((item, itemIndex) => {
			const selected = itemIndex === active;
			item.classList.toggle('is-active', selected);
			item.setAttribute('aria-selected', selected ? 'true' : 'false');
		});
		panels.forEach((panel, panelIndex) => panel.classList.toggle('is-active', panelIndex === active));
	};

	tabs.forEach((tab, index) => tab.addEventListener('click', () => show(index)));
	let timer = window.setInterval(() => show(active + 1), 5000);
	const pause = () => window.clearInterval(timer);
	const resume = () => {
		window.clearInterval(timer);
		timer = window.setInterval(() => show(active + 1), 5000);
	};
	premieres.addEventListener('pointerenter', pause);
	premieres.addEventListener('pointerleave', resume);
	premieres.addEventListener('focusin', pause);
	premieres.addEventListener('focusout', resume);
});
